import { Component, OnDestroy, OnInit, forwardRef, Inject, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { LegalRepresentationState, LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';
//import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
//import { DomainCodes } from '../../../../../../models/const.DomainCodes';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';


@Component({
  selector: 'legal-representation-identification',
  templateUrl: './legal-representation-identification.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class LegalRepresentationIdentificationComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  @Input("cardData")
  public cardData: models.LegalRepresentationIdentificationVM = {} as models.LegalRepresentationIdentificationVM;
  //@Input() benefitChoosen: BenefitChoosen;
  //public BenefitChoosen = BenefitChoosen;

  @Input("yesNo")
  public yesNo: models.DimensionVM[];

  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  @Input() isServiceOrFunerary: boolean;
  //@CommonData(DomainCodes.country)
  public typesRepresentation: models.DimensionVM[];

  public dropListRepresentationType: models.Options[] = [];

  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component, private modalService: ModalService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData =(<any>parent)._cardData;
  }

  ngOnInit(): void {
    this.dropListRepresentationType = (this.parent as BeneficiaryListTableEditComponent).dropdowns.options
      .filter(el => el.dropdown === "DropdownRepresentationType");
  }

  ngOnDestroy(): void {
  }

  public isStateRLDiferido(): boolean {
    return this.cardData.stateRL === LegalRepresentationState.RepresentacaoDeferida;
  }

  public isStateRLIndeferido(): boolean {
    return this.cardData.stateRL === LegalRepresentationState.RepresentaçaoIndeferida;
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public getEstadoRepresentacaoLegal(): string {
    const result = this.beneficiariesStateService
      .getStateText(this.cardData.stateRL?.toString());
    return result;
  }

  public getIconRepresentacaoLegal(): string {
    const result = this.beneficiariesStateService
      .getStateIcon(this.cardData.stateRL?.toString());
    return result;
  }


  public getColorRepresentacaoLegal(): string {
    const result = this.beneficiariesStateService
      .getStateColor(this.cardData.stateRL?.toString());
    return result;
  }
}
